import React from 'react';
import { PageWithNavigation } from './common/Navigation/PageWithNavigation';

export const FourOhFourPage: React.SFC = () => (
	<PageWithNavigation>
		<h2 className="has-text-centered is-size-3">Page was not found</h2>
	</PageWithNavigation>
);
